// Maps an Automation rule type onto the slice of the rule-statement payload
// that describes it (see GetRuleStatementsDataAPI).
//
// Every rule type must appear here. When a rule type was missing, the callers
// left `operatorLookupsData` holding whatever the fallback expression produced
// -- the string 'policy' in the add dialog, the empty string in the edit dialog
// -- and opening either one died with "operatorLookupsData.map is not a
// function". The accessors below always hand back the right shape, so a rule
// type that is not wired up yet renders empty instead of throwing.
export const RULE_TYPE_DATA_KEY = {
    group: 'group',
    policy: 'policy',
    license: 'license',
    energy_group: 'rates'
};

export const getRuleTypeData = (commonData, ruleType) => (commonData && commonData[RULE_TYPE_DATA_KEY[ruleType]]) || {};

export const getOperatorLookups = (commonData, ruleType) => getRuleTypeData(commonData, ruleType).operator_lookups || [];

export const getAttributes = (commonData, ruleType) => getRuleTypeData(commonData, ruleType).attributes || [];

export const getDefaultOrderValue = (commonData, ruleType) => getRuleTypeData(commonData, ruleType).default_order_value || 1;

// The 'Do NOT license' choice: "matched, but deliberately given no licence",
// stored as NULL in Rule.licenseid.
//
// This has to be a non-empty id. MUI's Select treats value="" as "nothing
// selected", so a rule already set to 'Do NOT license' opened with a blank
// pull-down instead of showing its actual setting. The sentinel is translated
// back to '' by toLicenseIdPayload() on the way to the API.
export const DO_NOT_LICENSE_ID = 'do-not-license';
export const DO_NOT_LICENSE_LABEL = 'Do NOT license';
export const DO_NOT_LICENSE_TYPEVAL = '131072';

export const getLicenseOptions = (commonData) => [
    { id: DO_NOT_LICENSE_ID, label: DO_NOT_LICENSE_LABEL },
    ...(getRuleTypeData(commonData, 'license').license_data || []).map((license) => ({
        id: license.id,
        label: license.label || license.name || 'Unknown'
    }))
];

// Rule.licenseid is null for 'Do NOT license'; map that onto the sentinel so
// the pull-down shows the rule's real setting when the edit dialog opens.
export const toLicenseSelection = (licenseId) =>
    licenseId === null || licenseId === undefined || licenseId === '' ? DO_NOT_LICENSE_ID : licenseId;

// '' tells the backend to store NULL in Rule.licenseid.
export const toLicenseIdPayload = (selection) => (selection === DO_NOT_LICENSE_ID ? '' : selection);
